// extracted by mini-css-extract-plugin
module.exports = {"container-toggle-sound":"ToggleSound_container-toggle-sound__1vKSD","label":"ToggleSound_label__3r870"};